import api from './api';

export const getAdminStats = async () => {
  const response = await api.get('/admin/stats');
  return response.data;
};

export const getAdminGroups = async () => {
  const response = await api.get('/admin/groups');
  return response.data;
};

export const updateGroupScanLimit = async (groupId, scanLimit) => {
  const response = await api.put(`/admin/groups/${groupId}/scan-limit`, { scanLimit });
  return response.data;
};

export const deleteGroup = async (groupId) => {
  const response = await api.delete(`/admin/groups/${groupId}`);
  return response.data;
};

export const downloadEmailsCsv = async () => {
  const response = await api.get('/admin/emails/csv', { responseType: 'blob' });
  return response.data; // a Blob
};

export const updatePdfExportGlobal = async (enabled) => {
  const response = await api.put('/admin/settings/pdf-export-global', { enabled });
  return response.data;
};

export const updateGroupPdfExport = async (groupId, value) => {
  const response = await api.put(`/admin/groups/${groupId}/pdf-export`, { value });
  return response.data;
};

export const compGroup = async (groupId, planKey) => {
  const response = await api.put(`/admin/groups/${groupId}/comp`, { planKey });
  return response.data;
};

export const updateScanCostEstimate = async (costPerScanCents) => {
  const response = await api.put('/admin/settings/scan-cost', { costPerScanCents });
  return response.data;
};

export const getUsersWithoutGroup = async () => {
  const response = await api.get('/admin/users/no-group');
  return response.data;
};

export const downloadUsersWithoutGroupCsv = async () => {
  const response = await api.get('/admin/users/no-group/csv', { responseType: 'blob' });
  return response.data; // a Blob
};

export const deleteUsersWithoutGroup = async (olderThan) => {
  const response = await api.delete('/admin/users/no-group', { params: { olderThan } });
  return response.data;
};

export const getGroupsMembersReport = async () => {
  const response = await api.get('/admin/groups-members-report');
  return response.data;
};

export const downloadGroupsMembersReportCsv = async () => {
  const response = await api.get('/admin/groups-members-report/csv', { responseType: 'blob' });
  return response.data; // a Blob
};

export const generateGiftCodeBatch = async ({ planKey, quantity, campaignLabel }) => {
  const response = await api.post('/admin/gift-codes/batch', { planKey, quantity, campaignLabel });
  return response.data;
};

export const getGiftCodeCampaignReport = async () => {
  const response = await api.get('/admin/gift-codes/campaigns');
  return response.data;
};

export const transferGroupOwnership = async (groupId, newOwnerUserId) => {
  const response = await api.put(`/admin/groups/${groupId}/transfer-owner`, { newOwnerUserId });
  return response.data;
};
